import { render, staticRenderFns } from "./vehicleinspectionviewdetails.vue?vue&type=template&id=c81bcf0c&scoped=true"
import script from "./vehicleinspectionviewdetails.vue?vue&type=script&lang=js"
export * from "./vehicleinspectionviewdetails.vue?vue&type=script&lang=js"
import style0 from "./vehicleinspectionviewdetails.vue?vue&type=style&index=0&id=c81bcf0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81bcf0c",
  null
  
)

export default component.exports